import { useSyncExternalStore } from "react";

const STORAGE_KEY = "xianjian-favorites";

function readFavorites(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

let favorites: string[] = readFavorites();
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return favorites;
}

export function toggleFavorite(id: string) {
  favorites = favorites.includes(id)
    ? favorites.filter((item) => item !== id)
    : [...favorites, id];
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  } catch {
    // 忽略存储异常
  }
  emit();
}

export function useFavorites() {
  const list = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return {
    favorites: list,
    isFavorite: (id: string) => list.includes(id),
    count: list.length,
    toggleFavorite,
  };
}